export default {
    adminSubMenu: {
        home: 'Kezdőlap',
        hive: 'Kaptár',
        news: 'Hírek',
        menuOpenAndClose: 'Menü nyitás/zárás',
        toggleTheme: 'Sötét/Világos téma',
        toggleWorkspace: 'Organizációk',
        settings: 'Beállítások',
        general: 'Általános',
        accountSettings: 'Fiókbeállítások',
        organization: 'Organizáció kezelés',
        suggestAFeature: 'Javasolj egy funkciót',
        help: 'Segítség'
    },
    settings: {
        settings: 'Beállítások',
        accountSettings: 'Fiókbeállítások',
        profile: 'Profil',
        personalDetails: 'Személyes adatok',
        password: 'Jelszó',
        created: 'Létrehozva',
        update: 'Frissítés',
        profileImage:"Profil kép",
        signedInDevices: 'Bejelentkezett eszközök',
        signOut: 'Kijelentkeztetés',
        save: 'Mentés',
        username: 'Felhasználónév',
        email: 'E-mail',
        firstName: 'Keresztnév',
        lastName: 'Vezetéknév',
        currentSession: 'Jelenlegi munkamenet',
        ipAddress: 'IP cím',
        lastAccessed: 'Legutolsó bejelentkezés',
        clients: 'Kliensek',
        started: 'Kezdett',
        expires: 'Lezárt',
        yourSessionExpiredSoon: 'A munkamenet hamarosan lejár, folytatni szeretné?',
        yourSessionExpiredSoonMessage:
            'A munkameneted hamarosan lejár! Folytathatja a jelenlegi munkamenetet',
        stayLoggedIn: 'Maradjon bejelentkezve',
        yourSessionExpired: 'A munkamenet lejárt',
        yourSessionExpiredMessage:
            'Az adminisztrációs panel munkamenete lejárt, nem kell aggódnia, bármikor újra bejelentkezhet.',
        reLogin: 'Újra bejelentkezés',
        logout: 'Kijelentkezés',
        create: 'Létrehozás',
        warning: 'Figyelmeztetés',
        createOrganization: 'Organizáció létrehozás',
        uploadIcon: 'Kattints ide az ikon feltöltéséhez',
        name: 'Név',
        description: 'Leírás',
        deleteOrganization: 'Biztosan törölni szeretné az organizációt?',
        leaveOrganization: 'Biztosan el akarja hagyni az organizációt?',
        delete: 'Törlés',
        leave: 'Elhagyás',
        cancel: 'Mégse',
        deleteComplete: 'Sikeresen törölte az organizációt.',
        leaveComplete: 'Sikeresen elhagyta az organizációt.',
        somethingWentWrong: 'Valami hiba történt, kérjük próbálja újra később.',
        editOrganization: '{name} organizáció szerkesztése',
        myOrganizations: 'Saját organizációim',
        teamManagement: 'Csapatkezelés',
        requiredField: 'Kötelező mező',
        minMaxCharacters: '{text} 1-255 karakternek kell lennie!',
        organizationCharacters: 'Az organizáció nevének'
    }
}
